import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {ResultsVersionsConfig, ResultsVersionsConfigJson} from './results-versions-config';
import {MeasurementsConfig, MeasurementsConfigJson} from './measurements-config';

export type ConfigJson = {
  notForClinicalUse: boolean;
  dualFactorAuthRegenerateIntervalInSeconds: number;
  resultsVersions: ResultsVersionsConfigJson;
  measurements: MeasurementsConfigJson;
};

export class Config implements JsonConfigInterface<ConfigJson> {

  public readonly resultsVersions: ResultsVersionsConfig = new ResultsVersionsConfig();
  public readonly measurements: MeasurementsConfig = new MeasurementsConfig();

  private _notForClinicalUse: boolean = false;
  private _dualFactorAuthRegenerateIntervalInSeconds: number = 0;

  constructor(json?: ConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get notForClinicalUse(): boolean {
    return this._notForClinicalUse;
  }

  public get dualFactorAuthRegenerateIntervalInSeconds(): number {
    return this._dualFactorAuthRegenerateIntervalInSeconds;
  }

  public deserializeJson(json: ConfigJson): void {
    this._notForClinicalUse = json.notForClinicalUse;
    this._dualFactorAuthRegenerateIntervalInSeconds = json.dualFactorAuthRegenerateIntervalInSeconds;
    this.resultsVersions.deserializeJson(json.resultsVersions);
    this.measurements.deserializeJson(json.measurements);
  }
}
